import { render, staticRenderFns } from "./recommend_news.vue?vue&type=template&id=7a4e074e&scoped=true"
import script from "./recommend_news.vue?vue&type=script&lang=js"
export * from "./recommend_news.vue?vue&type=script&lang=js"
import style0 from "./recommend_news.vue?vue&type=style&index=0&id=7a4e074e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e074e",
  null
  
)

export default component.exports